// src/components/Muestras/MuestraChat.js
import { useCallback } from "react";
import EntityChat from "../Chat/EntityChat";
import EntityChatNotasPanel from "../Chat/EntityChatNotasPanel";
import {
  getFilesByMuestraId,
  uploadFileToMuestra,
} from "../../api/Muestras/muestraApi";
import { getFileContent } from "../../api/Design/fileApi";

export default function MuestraChat({
  open,
  onClose,
  muestra,
  initialTab = "mensajes",
  onNotasChanged,
}) {
  const muestraId = muestra?.ID_MUESTRA || muestra?.id;

  const resolveAttachment = useCallback(
    async (fileRef) => {
      if (!muestraId || !fileRef) return null;

      let path = String(fileRef).replace(/\\/g, "/");

      // Legacy messages stored only the file name — resolve against sample files
      if (!path.includes("/")) {
        const files = await getFilesByMuestraId(muestraId);
        const match = (files || []).find((f) => {
          const name = f.name || f.fileName;
          const fPath = String(f.path || "").replace(/\\/g, "/");
          return name === path || fPath.endsWith(`/${path}`) || fPath === path;
        });
        if (!match?.path) return null;
        path = String(match.path).replace(/\\/g, "/");
      }

      const response = await getFileContent(path);
      const { mimeType, data } = response?.data || {};
      if (!data) return null;

      return {
        url: `data:${mimeType};base64,${data}`,
        fileName: path.split("/").pop(),
      };
    },
    [muestraId]
  );

  return (
    <EntityChat
      open={open}
      onClose={onClose}
      entityType="Muestra"
      entityId={muestraId}
      title={muestra?.MUESTRA || "Sample"}
      subtitle={muestra?.MARCA || muestra?.NOMBRE_CLIENTE || ""}
      initialTab={initialTab}
      secondaryTab={{
        label: "Notas",
        content: (
          <EntityChatNotasPanel
            active={open}
            idMuestra={muestraId}
            onChanged={onNotasChanged}
          />
        ),
      }}
      resolveAttachment={resolveAttachment}
      uploadFile={async (file) => {
        const uploaded = await uploadFileToMuestra(muestraId, file);
        const path = uploaded?.path || file.name;
        return `📎 File uploaded: ${path}`;
      }}
    />
  );
}
